export { default } from "./FilterDetails";
